import { radarPortOverrideStorage } from "./radar-port-override";

const RADAR_SYSTEM_CONFIG_SUFFIX_QUERY_PARAM = "radarSystemConfigSuffix";

/**
 * Reads the radar system-config URL suffix override from a boot-time query
 * param, e.g. `?radarSystemConfigSuffix=:9999/api/system_config`, and
 * persists it the same way the debug tab does. Lets Playwright set the
 * override by navigating to a URL instead of driving the debug UI; the
 * embedded Android app never sends this param, so it is unaffected.
 */
export async function applyRadarSystemConfigOverrideFromQueryParam(
  search: string
): Promise<void> {
  const params = new URLSearchParams(search);
  if (!params.has(RADAR_SYSTEM_CONFIG_SUFFIX_QUERY_PARAM)) {
    return;
  }

  const value = params.get(RADAR_SYSTEM_CONFIG_SUFFIX_QUERY_PARAM) ?? "";
  if (value.trim()) {
    await radarPortOverrideStorage.set(value);
  } else {
    await radarPortOverrideStorage.clear();
  }
}
